<div class="p-5">
  <div class="flex justify-between items-center mb-2">
    <div class="text-lg text-gray-700 font-bold">Registrar ocorrência</div>
    <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="text-sm text-gray-500 mb-4">TG {{ data.codigoTg }} · OS {{ data.codigoOs }}</div>

  <div [formGroup]="form" class="flex flex-col gap-1">
    <div class="flex flex-row justify-between items-center w-full">
      <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Fase</mat-label>
        <mat-select formControlName="fase">
          @for (fase of fases; track fase) {
            <mat-option [value]="fase">{{ fase }} — {{ nomeFase[fase] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Modelo de ocorrência</mat-label>
        <mat-select formControlName="ocorrenciaId" [disabled]="!form.get('fase')?.value">
          @for (item of catalogo; track item.id) {
            <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-row justify-between items-center w-full">
      <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Data ocorrido</mat-label>
        <input matInput [matDatepicker]="dataOcorrido" formControlName="dataOcorrido" />
        <mat-datepicker-toggle matSuffix [for]="dataOcorrido"></mat-datepicker-toggle>
        <mat-datepicker #dataOcorrido></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Hora ocorrido</mat-label>
        <input matInput type="time" formControlName="horaOcorrido" />
      </mat-form-field>
    </div>

    <mat-form-field class="input-tg w-full px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Observação</mat-label>
      <textarea matInput formControlName="observacao" rows="2"></textarea>
    </mat-form-field>
  </div>

  <div class="flex justify-end gap-2 mt-4">
    <button mat-flat-button class="btn-tg-white" (click)="close()">Cancelar</button>
    <button mat-flat-button class="btn-tg" [disabled]="form.invalid || saving" (click)="registrar()">
      @if (saving) {
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
      } @else {
        Registrar
      }
    </button>
  </div>
</div>
